__turbopack_context__.v({
  "bottomLinks": "Hero-module-scss-module__qMGq8W__bottomLinks",
  "browserLink": "Hero-module-scss-module__qMGq8W__browserLink",
  "buttons": "Hero-module-scss-module__qMGq8W__buttons",
  "content": "Hero-module-scss-module__qMGq8W__content",
  "ctaContent": "Hero-module-scss-module__qMGq8W__ctaContent",
  "ctaDesktop": "Hero-module-scss-module__qMGq8W__ctaDesktop",
  "ctaMobile": "Hero-module-scss-module__qMGq8W__ctaMobile",
  "heading": "Hero-module-scss-module__qMGq8W__heading",
  "hero": "Hero-module-scss-module__qMGq8W__hero",
  "imageLinks": "Hero-module-scss-module__qMGq8W__imageLinks",
  "imageWrapper": "Hero-module-scss-module__qMGq8W__imageWrapper",
  "innerContent": "Hero-module-scss-module__qMGq8W__innerContent",
  "lead": "Hero-module-scss-module__qMGq8W__lead",
  "mainText": "Hero-module-scss-module__qMGq8W__mainText",
  "registerBtn": "Hero-module-scss-module__qMGq8W__registerBtn",
  "secondaryBtn": "Hero-module-scss-module__qMGq8W__secondaryBtn",
  "separator": "Hero-module-scss-module__qMGq8W__separator",
  "topRight": "Hero-module-scss-module__qMGq8W__topRight",
  "users": "Hero-module-scss-module__qMGq8W__users",
  "usersSticker": "Hero-module-scss-module__qMGq8W__usersSticker",
});
